import { useEffect, useState } from 'react';
import { lightTheme } from './ui/theme/theme';
import { ThemeProvider } from '@emotion/react';
import { AppContent } from './ui/AppContent';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { PrivacyPolicy } from './ui/pages/PrivacyPolicy';
import { Agreement } from './ui/pages/Agreement';
import { Questionnaire } from './ui/pages/questionnaire/Questionnaire';
import { Editor } from './ui/pages/editor/Editor';
import { SEO } from './ui/components/SEO';
import { LanguageHandler } from './ui/components/LanguageHandler';

const App = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <ThemeProvider theme={lightTheme}>
      <SEO />
      <BrowserRouter>
        <LanguageHandler />
        <Routes>
          <Route path="" element={<AppContent />} />
          <Route path="/" element={<AppContent />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/agreement" element={<Agreement />} />
          <Route path="/questionnaire" element={<Questionnaire />} />
          <Route path="/editor/:branchNameBase64" element={<Editor />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
